import React, { useState, useMemo, useEffect } from 'react'
import FlowerImg from '../../assets/images/signup/flower.png'
import { getUrlParams } from '../../utils/helpers/common'
import { supportProgramTypes } from '../../constants/support-programs'
import constants from '../../constants'
import SignupPageHeader from './SignupPageHeader'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import DiasensImage from '../../assets/images/diasens.webp'
import GoodFlipImage from '../../assets/images/logos/goodflip.webp'
import GlucoLiveImage from '../../assets/images/logos/glucolive.webp'
import FullName from '../../components/Signup/FullName'
import { getCgmTypeFromHostname } from '../../utils/helpers/cgmHostname'

const UserProfileDetails = ({ onFinish, loading }) => {
  const params = getUrlParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { verifyOtp } = useSelector((s) => s.auth)
  const authData = verifyOtp?.data?.data || {}
  const [formFields, setFormFields] = useState({
    name: '',
    state: '',
    city: '',
    gender: '',
    dob: '',
  })
  const [currentStep, setCurrentStep] = useState(0)

  const handleChange = (field, value) => {
    setFormFields({ ...formFields, [field]: value })
  }

  // Determine if this is a CGM flow
  const isCgmFlow = Boolean(params?.cgm) || location.state?.isCgmFlow
  const cgmType =
    params?.cgm ||
    (location.state?.isCgmFlow ? getCgmTypeFromHostname() : undefined)

  // Get the appropriate configuration
  const supportProgramName = isCgmFlow ? cgmType : params?.support_program_type
  const supportProgram = supportProgramTypes[supportProgramName]

  // Use CGM onboarding steps if it's a CGM flow, otherwise use PSP steps
  const onboardingSteps = supportProgram?.onboarding_steps || []

  const activeStep = onboardingSteps[currentStep]

  const handleFinish = () => {
    onFinish(formFields)
  }
  const rightImage =
    location.state?.programLogo ||
    (isCgmFlow
      ? cgmType === constants.CGM_TYPE.DIASENS
        ? DiasensImage
        : cgmType === constants.CGM_TYPE.GLUCOLIVE
          ? GlucoLiveImage
          : GoodFlipImage
      : params?.support_program_type === constants.CARE_PROGRAM_TYPE.DIASENS
        ? DiasensImage
        : params?.support_program_type === constants.CARE_PROGRAM_TYPE.GOODFLIP
          ? GoodFlipImage
          : DiasensImage)

  useEffect(() => {
    if (
      authData?.is_plan_expired === 0 &&
      authData?.patient_meta_info?.support_program_key ===
        constants.CARE_PROGRAM_TYPE.VIEMAX
    ) {
      // setCurrentStep(2)
      setFormFields({
        name: authData?.name,
        state: authData?.state,
        city: authData?.city,
        gender: authData?.gender,
        dob: authData?.dob,
      })
    }
  }, [authData?.is_plan_expired])

  const handleNextStep = () => {
    if (currentStep !== onboardingSteps?.length - 1) {
      setCurrentStep(currentStep + 1)
    } else {
      if (!loading) {
        handleFinish()
      }
    }
  }

  const handlePreviousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1)
      return
    } else if (isCgmFlow) {
      // For CGM flow, go back to the landing page
      navigate(-1)
    } else if (supportProgramName) {
      navigate(
        `/programs/${supportProgramName}?support_program_type=${supportProgramName}`,
      )
    }
  }

  const progress = useMemo(() => {
    return ((currentStep + 1) / onboardingSteps?.length) * 100
  }, [currentStep, onboardingSteps])

  return (
    <div className="min-w-sm max-w-lg pb-[98px] mx-auto w-full overflow-hidden">
      {/* Page header and Progress Bar */}
      <SignupPageHeader
        handlePreviousStep={handlePreviousStep}
        progress={progress}
        step={currentStep}
        totalSteps={onboardingSteps?.length}
        cgmType={cgmType}
        {...((isCgmFlow &&
          cgmType &&
          (cgmType === constants.CGM_TYPE.DIASENS ||
            cgmType === constants.CGM_TYPE.GLUCOLIVE)) ||
        supportProgramName === constants.CARE_PROGRAM_TYPE.DIASENS ||
        supportProgramName === constants.CARE_PROGRAM_TYPE.GLUCOLIVE
          ? {
              themeColor: '#C14FA5',
              rightImage: rightImage,
            }
          : isCgmFlow
            ? { rightImage: rightImage }
            : {})}
      />
      <div className="relative">
        {activeStep?.hideImage ? null : (
          <img
            src={FlowerImg}
            alt="flower"
            className="w-[160px] h-[160px] absolute -z-10 top-0 right-0 -mr-[2px]"
          />
        )}
        {activeStep?.Component ? (
          <div className={classNames('pb-8', activeStep?.bg)}>
            <activeStep.Component
              name={activeStep?.name}
              value={formFields[activeStep?.name]}
              formObj={formFields}
              onChange={handleChange}
              onMoveNext={handleNextStep}
              onSkip={handleNextStep}
              loading={loading}
              isLastStep={currentStep === onboardingSteps?.length - 1}
              title={activeStep?.title}
              subtitle={activeStep?.subtitle}
              canSkip={activeStep?.canSkip}
            />
          </div>
        ) : null}

        {/* {activeStep?.hideButton ? (
          <></>
        ) : (
          <div className="fixed bottom-0 left-0 right-0 p-4 min-w-sm max-w-lg mx-auto w-full bg-white">
            <Button
              fullWidth
              onClick={handleNextStep}
              disabled={loading}
              loading={loading}
            >
              {currentStep !== onboardingSteps?.length - 1
                ? 'Continue'
                : "Let's get started"}
              <img src={ArrowRightIcon} />
            </Button>
          </div>
        )} */}
      </div>
    </div>
  )
}

export default UserProfileDetails
